// @claude-owned: TimerImmersiveContext extraction — sprint P0 v3
import { createContext, useCallback, useContext, useMemo, useState, ReactNode } from 'react';

interface TimerImmersiveCtx {
  isImmersive: boolean;
  setImmersive: (v: boolean) => void;
}

const Ctx = createContext<TimerImmersiveCtx>({
  isImmersive: false,
  setImmersive: () => {},
});

export function TimerImmersiveProvider({ children }: { children: ReactNode }) {
  const [isImmersive, setImmersiveState] = useState(false);
  const setImmersive = useCallback((v: boolean) => setImmersiveState(v), []);
  const value = useMemo(() => ({ isImmersive, setImmersive }), [isImmersive, setImmersive]);
  return <Ctx.Provider value={value}>{children}</Ctx.Provider>;
}

export function useTimerImmersive() {
  return useContext(Ctx);
}